import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../../../api/axios';
import BottomNav from '../../../components/BottomNav';
import DoctorCard from '../../../components/card/DoctorCard';
import DoctorFilterBottomSheet from '../../../components/filter/DoctorFilterBottomSheet';
import HeaderWithBack from '../../../components/HeaderWithBack';
import Loading from '../../../components/Loading';
import Service from '../../../components/modal/Service';
import InfoModal from '../../../components/modal/InfoModal';
import { activeConsultationMessage, activeConsultationRoute, isActiveConsultation } from '../../../utils/activeConsultation';
import { useAuthStore } from '../../../stores/authStores';

// tipe Doctor
type Doctor = {
  practitioner_role_id: string;
  name: string;
  specialization: string;
  years: number;
  rating: number;
  hospital: string;
  price_chat: number;
  price_video: number;
  originalPrice?: number;
  photoUrl: string;
  is_online: boolean;
  availability?: string;
};

const ListDoctor: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialFilters = location.state?.filters || {};

  // ⬇️ Ini harus di dalam komponen
  const [showFilter, setShowFilter] = useState(false);
  const [showService, setShowService] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState<Doctor | null>(null);
  const [doctorData, setDoctorData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    gender: '',
    experience: '',
    schedule: '',
    specialistId: '',
    ...initialFilters
  });
  const [homeData, setHomeData] = React.useState<any>(null);
  const isFilterActive = Object.values(filters).some(value => value !== '' && value !== null);
  const userData = useAuthStore((state) => state.user);
  const authToken = useAuthStore((state) => state.token);
  const [ isLoading, setIsLoading ] = useState<boolean>(true)

  const [showActiveConsultation, setShowActiveConsultation] = useState(false);

  const handleKonsultasiClick = async (doctor: Doctor) => {
    let latestHome = homeData;
    try {
      const response = await axios.get('home', {
        params: { user_id: userData?.id },
        headers: { Authorization: `Bearer ${authToken}` },
      });
      latestHome = response.data.data;
      setHomeData(latestHome);
    } catch (error) {
      console.error('Error fetching data:', error);
    }

    if (isActiveConsultation(latestHome?.teleconsult)) {
      setShowActiveConsultation(true);
      return;
    }
    setSelectedDoctor(doctor);
    setShowService(true);
  };

  useEffect(() => {
    if (!authToken) return;

    const delay = setTimeout(async () => {
      try {
        const params: Record<string, any> = { page: 1 };

        if (searchTerm?.trim()) {
          params.search = searchTerm.trim();
        }

        if (filters.gender) {
          params.gender = filters.gender;
        }

        if (filters.experience) {
          params.experience = Number(filters.experience);
        }

        if (filters.schedule) {
          params.availabilityStatus = filters.schedule;
        }

        if (filters.speciality_id) {
          params.speciality_id = filters.speciality_id;
        }

        const response = await axios.get(`practitoner-roles`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
          params,
        });

        const practitionerDoctors = response.data.data.map(
          (item: any, index: number) => ({
            practitioner_role_id: item.id,
            name: item.doctorName,
            specialization: item.doctorSpeciality || 'Umum',
            years: item.experience,
            rating: Math.round((item.rating || 0) * 20),
            hospital: item.hospital_name?.replace(/\r?\n|\r/g, '').trim() || '',
            price_chat: item.price_chat,
            price_video: item.price_video,
            photoUrl:
              item.photoUrl || `https://i.pravatar.cc/150?img=${index + 1}`,
            is_online: item.availabilityStatus === 'ONLINE',
            availability: item.availabilityStatus,
          })
        );

        setDoctorData(practitionerDoctors);
      } catch (error) {
        console.error('Error fetching practitioner:', error);
      } finally {
        setIsLoading(false);
      }
    }, 200); 

    return () => clearTimeout(delay);
  }, [authToken, searchTerm, filters]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`home`, {
          params: {
            user_id: userData?.id,
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
          }
        });

        const data = response.data.data;
        console.log(data, "data");
        setHomeData(data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchData(); // Selalu fetch saat Home dirender
  }, [authToken, userData?.id]);

  const handleServiceSubmit = (data: { waktu: 'sekarang' | 'jadwal'; layanan: string }) => {
    setShowService(false);
    // if (data.waktu === 'jadwal' && selectedDoctor) {
    //   navigate(`/schedule-consultation/${selectedDoctor?.practitioner_role_id}`, {
    //     state: { doctor: selectedDoctor },
    //   });
    // }

    // if (data.waktu === 'sekarang') {
    //   // handle konsultasi sekarang jika perlu
    //   navigate(`/disclaimer/${selectedDoctor?.practitioner_role_id}`);
    // }

    if (isActiveConsultation(homeData?.teleconsult)) {
      navigate(activeConsultationRoute(homeData.teleconsult));
    } else {
      if (data.waktu === 'sekarang') {
        navigate(`/disclaimer/${selectedDoctor?.practitioner_role_id}`);
      } else {
        navigate(`/schedule-consultation/${selectedDoctor?.name}`, {
        state: { doctor: selectedDoctor },
      });
    }
    }
  };
  

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <HeaderWithBack title="Tanya Dokter Kami" />

      {/* Header + Tombol Filter */}
      <div className="flex justify-between items-center px-4 mt-4 mb-2">
        <h3 className="text-md font-semibold">Daftar Dokter</h3>
        <button onClick={() => setShowFilter(true)}  className="relative flex items-center border border-morning-300 text-morning-300 text-sm px-3 py-1 rounded-full">
          <img src="/app-icons/filter.svg" alt="Filter" className="w-4 h-4 mr-1" />
          Filter
          {isFilterActive && (
            <img src="/app-icons/checklist.svg" alt="Checklist" className="ml-2 w-4 h-4" />
          )}
        </button>
      </div>

      {/* Input Search */}
      <div className="px-4 mb-4">
        <div className="relative">
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <img src="/app-icons/search.svg" alt="Search" className="w-4 h-4 text-gray-400" />
          </span>
          <input
            type="text"
            placeholder="Cari Dokter, Spesialisasi"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border rounded-full text-sm placeholder-gray-400"
          />
        </div>
      </div>

      {/* List Dokter */}
      {isLoading ? 
      <div className="flex-1 flex items-center justify-center">
        <Loading />
      </div>
      :
      <div className="px-4 flex-1 overflow-y-auto pb-24">
        {!doctorData || doctorData.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-center mt-8">
            <img src="/images/empty-doctor.png" alt="No Doctor" className="w-[250px] h-[250px] object-contain" />
            <p className="mt-4 font-semibold">Belum ada dokter</p>
            <p className="text-sm text-gray-400">Belum ada data dokter yang dapat ditampilkan...</p>
          </div>
        ) : (
          doctorData.map((doc, index) => (
            <DoctorCard 
              key={index} 
              doctor={doc} 
              onConsult={() => handleKonsultasiClick(doc)}
            />
          ))
        )}
      </div>
      }

      {showFilter && (
        <>
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setShowFilter(false)}
        />
          <DoctorFilterBottomSheet
            filters={filters}
            setFilters={setFilters}
            onClose={() => setShowFilter(false)}
            onApply={() => {
              // logic filter di sini
              setShowFilter(false);
            }}
            onReset={() => {
              setFilters({ 
                gender: '',
                experience: '',
                schedule: '',
                specialistId: '',
               });
            }}
          />
        </>
      )}

      <Service
        isOpen={showService}
        onClose={() => setShowService(false)}
        onSubmit={handleServiceSubmit}
        isOnline={selectedDoctor?.is_online || false}
        prices={{
          chat: selectedDoctor?.price_chat,
          video: selectedDoctor?.price_video,
        }}
      />
      <InfoModal
        show={showActiveConsultation && isActiveConsultation(homeData?.teleconsult)}
        title="Konsultasi Masih Berjalan"
        message={isActiveConsultation(homeData?.teleconsult) ? activeConsultationMessage(homeData.teleconsult) : ''}
        actionLabel="Lihat Konsultasi"
        secondaryLabel="Tutup"
        onSecondary={() => setShowActiveConsultation(false)}
        onClose={() => {
          setShowActiveConsultation(false);
          if (isActiveConsultation(homeData?.teleconsult)) {
            navigate(activeConsultationRoute(homeData.teleconsult));
          }
        }}
      />
      <BottomNav />
    </div>
  );
};

export default ListDoctor;
